'use strict';

exports.__esModule = true;

var _doctifyModal = require('./components/doctify-modal');

Object.defineProperty(exports, 'DoctifyModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_doctifyModal).default;
  }
});

var _bookAppointmentModal = require('./components/book-appointment-modal');

Object.defineProperty(exports, 'BookAppointmentModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bookAppointmentModal).default;
  }
});

var _bookHealthCheckModal = require('./components/book-health-check-modal');

Object.defineProperty(exports, 'BookHealthCheckModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bookHealthCheckModal).default;
  }
});

var _requestAppointmentModal = require('./components/request-appointment-modal');

Object.defineProperty(exports, 'RequestAppointmentModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_requestAppointmentModal).default;
  }
});

var _telephoneModal = require('./components/telephone-modal');

Object.defineProperty(exports, 'TelephoneModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_telephoneModal).default;
  }
});

var _reportModal = require('./components/report-modal');

Object.defineProperty(exports, 'ReportModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reportModal).default;
  }
});

var _expiredSessionModal = require('./components/expired-session-modal');

Object.defineProperty(exports, 'ExpiredSessionModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_expiredSessionModal).default;
  }
});

var _somethingWentWrongModal = require('./components/something-went-wrong-modal');

Object.defineProperty(exports, 'SomethingWentWrongModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_somethingWentWrongModal).default;
  }
});

var _hospitalListModal = require('./components/hospital-list-modal');

Object.defineProperty(exports, 'HospitalListModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_hospitalListModal).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


// WEBPACK FOOTER //
// ./components/doctify-modals/lib/index.js